import { SET_ERROR } from "./constants";

function LocalSecurity(state = { message: "" }, action) {
  switch (action.type) {
    case SET_ERROR:
      return action.payload;
    default:
      return state;
  }
}

export { LocalSecurity };
